import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/platform-content/ai-training/')({
    beforeLoad: () => {
        throw redirect({
            to: '/admin-console/platform-content/ai-training/classification-example',
            replace: true,
        });
    },
});
